// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/dialog/handleDialogEscape.js#1 $
'use strict';

/**
* @ngdoc directive
* @name tcApp.directivess:tcHandleDialogEscape
* @description
* This is a helper directive to handle dialogs Escape key.
*/
angular.module('tcApp')
.directive('tcHandleDialogEscape', function($mdConstant, $window, $timeout, DialogService) {
	return {
		restrict: 'A',
		link: function(scope) {
			var bodyElement = angular.element($window.document.body);

			function escHandler($event) {
				if ($event.keyCode == $mdConstant.KEY_CODE.ESCAPE) {
					bodyElement.off('keydown',escHandler);
					$window.document.activeElement.blur();
					$event.preventDefault();
					$event.stopPropagation();
					$timeout(function() {DialogService.backDialog();});
				}
			}
			
			bodyElement.on('keydown',escHandler);

			scope.$on('$destroy', function() {
				bodyElement.off('keydown',escHandler);
			});
		}
	};
});
